import React, { useEffect, useState } from "react";
import { Matchmakers } from "../matchmakers";
import { Pagination } from "antd";
import profileImg from "../../assets/images/matchmakers/userProfile.png";
import profileImg1 from "../../assets/images/matchmakers/logo_nathi_profile_logo_1.png";
import { UserprofileEdit } from "../userprofileEdit/userprofileEdit";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { IoShareSocialOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import Preloader from "../../Components/Preloader";
import Modal from "react-bootstrap/Modal";
import { FaShare } from "react-icons/fa";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};

export function MatchProfileUpload() {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [profilesPerPage] = useState(4);
  const [currentProfiles, setCurrentProfiles] = useState([]);
  const [deleteId, setDeleteId] = useState();
  // const location = useLocation();
  // const { userId, biodataSet, matchmakerName } = location.state || {};
  // const { userId, matchmakerName, planType, publicToken } =
  //   location.state || {};
  // const params = useParams();
  // const userId = params.id;
  const navigate = useNavigate();

  // console.log("User ID:", userId);
  // console.log("Biodata Set:", biodataSet);
  // console.log("Matchmaker Name:", matchmakerName);
  // console.log("planType", planType);
  // console.log("public token", publicToken);

const storedData = JSON.parse(sessionStorage.getItem("matchmakerProfileData")) || {};

const {  agentId, matchmakerName, planType, publicToken,email,mobile} = storedData;

  //delete modal state
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  // basic plan modal
  const [basicshow, setBasicShow] = useState(false);

  const handleBasicClose = () => setBasicShow(false);
  const handleBasicShow = () => {
    setBasicShow(true);
  };

  useEffect(() => {
    // Only start interval if conditions are met
    if (profile.length >= 5 && planType === "Basic") {
      // Show immediately
      // setBasicShow(true);

      // Set interval to reopen modal every 3 seconds
      const intervalId = setInterval(() => {
        setBasicShow(true);
      }, 20000); 
     

      // Cleanup interval on unmount or condition change
      return () => clearInterval(intervalId);
    }
  }, [profile.length, planType]);

  // const calculateAge = (dob) => {
  //   const birthDate = new Date(dob);
  //   const ageDiff = new Date().getFullYear() - birthDate.getFullYear();
  //   return ageDiff;
  // };

  // useEffect(() => {
  //   // Transforming biodataSet into the desired format
  //   const transformedProfiles = (biodataSet || []).map((item) => ({
  //     image: item.profile || profileImg,
  //     username: item.name,
  //     role: `${item.employed_in || ""} - ${item.education || ""}`,
  //     years: `${calculateAge(item.dob)} yrs`,
  //     height: item.height ? `${item.height} ft` : "--",
  //     caste: `${item.caste || "--"}, ${item.religion || "--"}`,
  //     status: item.marital_status || "--",
  //     state: item.pob || "--", // Assuming state
  //     address: [item.address_l1, item.address_l2].filter(Boolean).join(", "),
  //   }));

  //   setProfile(transformedProfiles);
  //   setCurrentProfiles(transformeditem.slice(0, profilesPerPage));
  // }, [biodataSet, profilesPerPage]);
  async function LoadUser(agentId) {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get(
        `/admin/all-biodata/${agentId}`
      );
      if (response.data.status === true || response.status === 200) {
        console.log("response", response.data);
        setProfile(response.data.data);

        // initialize current page slice
        setCurrentProfiles(response.data.data.slice(0, profilesPerPage));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch users");
      console.log("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  }
  async function handleDeleteUser(id) {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.delete(`/admin/biodata/${id}`);
      if (response.data.status === true || response.status === 200) {
        console.log("response", response.data);
        toast.success(response.data.message || "profile deleted successfully!");
        LoadUser(agentId);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete!");
      console.log("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (agentId) {
      LoadUser(agentId);
    }
  }, []);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * profilesPerPage;
    const endIndex = startIndex + profilesPerPage;
    setCurrentProfiles(profile.slice(startIndex, endIndex));
  };

  // const isDisabled = true;

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />

      <div>
        <div className="matchUpload-subcontainer">
          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <Link to="/matchmakers">
              <div className="bi bi-arrow-left"></div>
            </Link>

            <div className="matchupload-title">
              Profiles Uploaded by{" "}
              <span className="text-uppercase">({matchmakerName || "--"}) </span>{" "}
              
            </div>
          </div>
          <div>
            {/* <Link to="/matchmaker-user-add">
             
            </Link> */}
            <button
              className="btnAdd me-2"
              // disabled
              // onClick={navigate("/user-profiles")}
              onClick={() =>
                navigate("/matchmaker-plans", {
                  // state: {
                  //   userId: userId,

                  //   matchmakerName: matchmakerName,
                  //   planType:planType,
                  // },
                })
              }
            >
              {" "}
              Plans
            </button>
            {planType !== "Basic" && (
              <button
                className="btnPublicShare me-2"
                onClick={() => {
                  // axiosInstance_agent.defaults.baseURL gives the API root
                  const url = `https://dev.agent.nathicharami.in/share-public-profile/${publicToken}/${matchmakerName}`;

                  window.open(url, "_blank");
                }}
              >
                <span className="me-2">
                  <FaShare />
                </span>
                Share Public Page
              </button>
            )}

            <button
              className="btnAdd"
              // disabled
              // onClick={navigate("/user-profiles")}
              onClick={() =>
                navigate("/matchmaker-user-add", {
                  // state: {
                  //   userId: userId,

                  //   matchmakerName: matchmakerName,
                  //   planType:planType,
                  // },
                })
              }
            >
              + Add Profile
            </button>
          </div>
        </div>
         <div className="my-3 totalProfiles">
          <span style={{ color: "#2b171b" }}>Plan Type : </span>
          <span style={{ color: "#2b171b" }}>{planType === "Recommended"
          ? "Standard"
          : planType}</span>
        </div>
        <div className="my-3 totalProfiles">
          <span style={{ color: "#2b171b" }}>Total profiles : </span>
          <span style={{ color: "#2b171b" }}>{profile.length}</span>
        </div>

        {/* user cards */}
        <div className="usercard-part">
          {currentProfiles.length > 0 ? (
            currentProfiles.map((item) => (
              // <div className="user-card">
              //           <div className="user-card-grid">
              //             <div className="user-card-img">
              //               {/* <img src={item.image} /> */}
              //               <img
              //                 src={item.image}
              //                 alt="profile"
              //                 onError={(e) => {
              //                   e.target.onerror = null;
              //                   e.target.src = profileImg1;
              //                 }}
              //               />
              //             </div>
              //             <div className="usercard-content">
              //               <div className="userName">{item.username}</div>
              //               <div className="content-sub">
              //                 <div>{item.role}</div>
              //                 <div>
              //                   <span>{item.years}</span>&nbsp;&nbsp;
              //                   <span>{item.height}</span>
              //                 </div>
              //                 <div>{item.caste}</div>
              //                 <div>{item.status}</div>
              //                 <div>{item.state}</div>
              //                 <div>{item.address}</div>
              //               </div>
              //             </div>
              //           </div>
              //           {/* <div className="usercard-viewCont">
              //             <div class="bi bi-trash3 delete-icon"></div>
              //             <div
              //               className="card-view"
              //               disabled
              //               onClick={() => {
              //                 if (typeof onContentChange === "function") {
              //                   onContentChange(() => (
              //                     <UserprofileEdit onContentChange={onContentChange} />
              //                   ));
              //                 }
              //               }}
              //             >
              //               View/Edit Profille
              //             </div>
              //           </div> */}

              //           {/* <div className="usercard-viewCont">
              //             <div className="bi bi-trash3 delete-icon"></div>
              //             <div
              //               className="card-view"
              //               // onClick={
              //               //   isDisabled
              //               //     ? undefined
              //               //     : () => {
              //               //         if (typeof onContentChange === "function") {
              //               //           onContentChange(() => (
              //               //             <UserprofileEdit
              //               //               onContentChange={onContentChange}
              //               //             />
              //               //           ));
              //               //         }
              //               //       }
              //               // }
              //               onClick={
              //                 isDisabled
              //                   ? undefined
              //                   : () => {
              //                     navigate("/userprofile-edit")
              //                     }
              //               }
              //               style={{
              //                 cursor: isDisabled ? "not-allowed" : "pointer",
              //                 opacity: isDisabled ? 0.5 : 1,
              //                 pointerEvents: isDisabled ? "none" : "auto", // Prevent all interactions
              //               }}
              //             >
              //               View/Edit Profille
              //             </div>
              //           </div> */}
              //         </div>
              <div className="viewcard" key={item.id}>
                <div className="viewcard-grid">
                  <div className="viewcardImg">
                    <img src={item.profile} alt="profileImg" />
                  </div>
                  <div className="viewcard-content">
                    <div className="viewcard-content-div">
                      <span>Name</span>
                      <span>{item.name || "---"}</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Education</span>
                      <span>{item.education || "---"}</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Occupation</span>
                      <span>{item.employed_in || "---"}</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Age</span>
                      <span>{item.age || "---"} years</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Religion</span>
                      <span>{item.religion || "---"}</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Caste</span>
                      <span>{item.caste || "---"}</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Marital Status</span>
                      <span>{item.marital_status || "---"}</span>
                    </div>
                    <div className="viewcard-content-div">
                      <span>Location</span>
                      <span>{item.state || "---"}</span>
                    </div>
                  </div>
                </div>

                <div className="viewcard-icons">
                  <div>
                    <span
                      className="me-1"
                      style={{
                        color: "#BDB7B8",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleShow(item.id)}
                    >
                      <RiDeleteBin6Line />
                    </span>
                    <span
                      className="me-3"
                      style={{
                        color: "#BDB7B8",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                      {/* <RiDeleteBin6Line onClick={() => handleDeleteShow(item.id)} /> */}
                    </span>
                    {/* <Link className="vieweditBtn" to={`/matchmaker-user-edit/${item.id}`}> */}
                    <span
                      className="vieweditBtn"
                      onClick={() =>
                        navigate(`/matchmaker-user-edit/${item.id}`, {
                          // state: {
                          //   userId: userId,
                          //   profileId: item.id,
                          //   matchmakerName: matchmakerName,
                          //   planType:planType,
                          // },
                           state: {
                         
                            profileId: item.id,
                          
                          },
                        })
                      }
                      style={{ color: "#BDB7B8", fontSize: "20px" }}
                    >
                      <FaRegEdit />
                    </span>
                    {/* </Link> */}
                  </div>
                  <div
                    className="card-view"
                    onClick={() =>
                      navigate("/view-profile", {
                        // state: {
                        //   userId: userId,
                        //   profileId: item.id,
                        //   matchmakerName: matchmakerName,
                        //   planType:planType,
                        // },
                         state: {
                    
                          profileId: item.id,
                        
                        },
                      })
                    }
                  >
                    View Profile
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{ fontSize: "16px", fontWeight: "400", marginTop: "20px" }}
            >
              Data not available
            </div>
          )}
        </div>
        {/* delete modal  */}
        <div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Delete</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="deleteText">
              Are you sure want to delete?
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <button
                variant="secondary"
                onClick={handleClose}
                className="deleteModalBtnCancel"
              >
                Cancel
              </button>
              <button
                variant="primary"
                onClick={() => {
                  handleClose();
                  handleDeleteUser(deleteId);
                }}
                className="deleteModalBtnDelete"
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="paginationContainer">
          <Pagination
            className="pagination"
            current={currentPage}
            pageSize={profilesPerPage}
            total={profile.length} // Total number of products
            onChange={handlePageChange} // Update displayed products
            showSizeChanger={false} // Disable page size changes
          />
        </div>
      </div>

      {/* 5 profile limit exceeded modal  */}
      <div>
        <Modal show={basicshow} centered className="basicPlanModalContainer">
          <Box sx={style}>
            <Typography id="modal-modal-title" className="headermodalTitle">
              Profile Limit Reached
            </Typography>
            <Typography
              id="modal-modal-description"
              className="headermodalDesc"
            >
              You have reached the limit of 5 profiles. Please upgrade your plan
              to continue adding more.
            </Typography>
            <div className="headerbtnContainer">
              <Button
                className="headermodalLogout"
                onClick={() =>
                  navigate("/matchmaker-plans", {
                    // state: {
                    //   userId: userId,

                    //   matchmakerName: matchmakerName,
                    //   planType:planType,
                    // },
                  })
                }
              >
                Upgrade Plan
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}
